(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/visibility-wrapper/assets/javascripts/visibility-wrapper.js') >= 0) return;  svs.modules.push('/components/tipsen/visibility-wrapper/assets/javascripts/visibility-wrapper.js'); "use strict";


const {
  useLayoutEffect,
  useRef
} = React;
const {
  useMediaQuery,
  features
} = svs.components.lbUtils.useMediaQuery;
const VisibilityWrapper = _ref => {
  let {
    children,
    className,
    HeaderComponent,
    isVisible,
    style
  } = _ref;
  const contentRef = useRef();
  const wrapperRef = useRef();
  const isInitialRender = useRef(true);
  const shouldReduceMotion = useMediaQuery(features.PREFERS_REDUCED_MOTION);

  useLayoutEffect(() => {
    const setVisibility = visible => {
      contentRef.current.style.visibility = visible ? '' : 'hidden';
    };
    if (isInitialRender.current) {
      setVisibility(isVisible);
      isInitialRender.current = false;
    }
    if (shouldReduceMotion) {
      setVisibility(isVisible);
      return;
    }
    const handleTransitionStart = event => {
      if (event.propertyName === 'grid-template-rows' && isVisible) {
        setVisibility(true);
      }
    };
    const wrapperElem = wrapperRef.current;
    wrapperElem.addEventListener('transitionstart', handleTransitionStart);
    return () => {
      wrapperElem.removeEventListener('transitionstart', handleTransitionStart);
    };
  }, [isVisible, shouldReduceMotion]);
  const handleTransitionEnd = event => {
    if (event.propertyName === 'grid-template-rows' && !isVisible) {
      contentRef.current.style.visibility = 'hidden';
    }
  };
  const classNames = ['visibility_wrapper'].concat(shouldReduceMotion ? 'visibility_wrapper--reduced-motion' : [], HeaderComponent ? 'visibility_wrapper--with-header' : [], isVisible ? 'visibility_wrapper--visible' : [], className || []).join(' ');
  return React.createElement("div", {
    className: classNames,
    onTransitionEnd: handleTransitionEnd,
    ref: wrapperRef,
    style: style
  }, HeaderComponent && React.createElement("div", {
    className: "visibility_wrapper__header"
  }, React.createElement(HeaderComponent, null)), React.createElement("div", {
    className: "visibility_wrapper__content",
    ref: contentRef
  }, children));
};
setGlobal('svs.components.tipsen.visibilityWrapper', {
  VisibilityWrapper
});
 })(window);